import { getJsapiParam } from '@/api';
import { cookie, util } from '@tencent/ppd-base-libs';
import { CustomException } from '@/utils/error';

import wx from '@/fit-components/jsapi/index';

/**
   * jsApi初始化
   * 端内打开中转页时，使用微信开放标签来做跳转。此时需要初始化微信jssdk
   */
export async function jsApiInit() {
  const [err, response] = await util.to(getJsapiParam(location.href));
  if (err) {
    console.error(err);
    throw new CustomException(err, 'getJsapiParamFailed', 'JSSDK初始化失败');
  }
  // 初始化微信jssdk
  wx.init({
    // @ts-ignore
    debug: false, // 调试时可开启
    appId: response.wx_config.appId, // <!-- replace -->
    timestamp: response.wx_config.timeStamp, // 必填，填任意数字即可
    nonceStr: response.wx_config.nonceStr, // 必填，填任意非空字符串即可
    signature: response.wx_config.signature, // 必填，填任意非空字符串即可
    jsApiList: ['chooseImage'], // 必填，随意一个接口即可
    openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
  });
}

export function getWxOpenid() {
  return cookie.get('mini_program_openid');
}
